import { CarModel } from './../models/CarModel';
import client from "./apolloClient";
import { GET_ALL_CAR_MODELS, GET_CARMODEL_BY_NAME } from './queries';



export const getAllCarModels = async (): Promise<CarModel[] | null> => {
    try {
        const { data } = await client.query({
            query: GET_ALL_CAR_MODELS,
        });

        return data?.getAllCarModels
    } catch (error) {
        console.log('Error fetching getAllCarModels:', error);
        return null;
    }
};

export const getCarModelByName = async (carModel: string): Promise<CarModel | null> => {
    try {
        const { data } = await client.query({
            query: GET_CARMODEL_BY_NAME,
            variables: { carModel }
        });

        return data?.getCarModelByName
    } catch (error) {
        console.log('Error fetching getCarModelByName:', error);
        return null;
    }
};



